/**
 * Comment-related strings.
 */
import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Icons from "../ui/IconButton/Icons";
import FontAwesomeButton from "../ui/Buttons/FontAwesomeButton";

export default {
	d_recoveryRates: 'Recovery Rates',
	h_recoveryRates: '<div><p>Recovery Rates shows the total billable amount, calculated at base rates with no discounting, along with the total amount collected.</p><p>The chart shows the recovery rates for all cases where the red flag is present.</p><p>Note that the recovery rate can be greater than 100%! This is common with fixed rates, where the amount of time put in was lower than expected.</p></div>',

	d_billedAndCollected: 'Billed and Collected',
	h_billedAndCollected: <div>
		<p>This chart shows the month-to-date billed and collected for each billable member of your team.</p>
		<p>To see date ranges outside of month-to-date, click on the <FontAwesomeIcon
			icon={Icons.ANALYTICS.reactIcon}
			color='purple'
		/> Analytics icon in the toolbar.</p>
		<div>
			<FontAwesomeButton icon={Icons.ANALYTICS.reactIcon}
			                   iconColor='purple'
			                   label='Analytics'
			                   route='/analytics'
			/>
		</div>
	</div>,
};